import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './styles.module.sass';
import LegalCosts from 'components/page/CollectionCaseEditor/ExpansionPanelPenaltyAndLegalCost/LegalCosts'
import Penalty from 'components/page/CollectionCaseEditor/ExpansionPanelPenaltyAndLegalCost/Penalty'
import Expansion from 'components/common/Expansion'
import Paper from '@material-ui/core/Paper'

class ExpansionPanelPenaltyAndLegalCost extends PureComponent {
  handlerOnChange = (nextValue) => {
    const {onChange} = this.props;
    if (onChange) onChange(nextValue);
  };


  render() {
    const {value = {}, collectionCaseSum} = this.props;
    return (
      <Expansion label={'Штрафы и судебные издержки'} defaultExpanded={true}>

        <Penalty className={styles.penalty} collectionCaseSum={collectionCaseSum} value={value.penalty} onChange={a => this.handlerOnChange({...value, penalty: a})} />

        <LegalCosts className={styles.legalCosts} value={value.legalCosts} onChange={a => this.handlerOnChange({...value, legalCosts: a})}/>
      </Expansion>
    );
  }
}

ExpansionPanelPenaltyAndLegalCost.propTypes = {
  collectionCaseSum: PropTypes.number,
  value: PropTypes.objectOf({
    penalty: PropTypes.object,
    legalCosts: PropTypes.array,
  }),

  onChange: PropTypes.func,
};

export default ExpansionPanelPenaltyAndLegalCost;


// WEBPACK FOOTER //
// ./src/components/page/CollectionCaseEditor/ExpansionPanelPenaltyAndLegalCost/ExpansionPanelPenaltyAndLegalCost.jsx